import { create } from 'zustand';

export const useApplicationMethodStore = create((set) => ({
  // Data state
  methods: [],
  selectedMethod: null,

  // Pagination
  paginationData: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
    hasNextPage: false,
    hasPreviousPage: false
  },

  // Column filters & unique values
  columnFilters: {},
  uniqueValues: {},

  // Status
  loading: false,
  error: null,

  // UI state
  isFormOpen: false,
  isEditMode: false,
  isDeleteDialogOpen: false,
  methodToDelete: null,
  methodToDelete: null,

  // === Pure State Setters ===
  setMethods: (methods) => set({ methods }),
  setSelectedMethod: (selectedMethod) => set({ selectedMethod }),
  setPaginationData: (paginationData) => set({ paginationData }),
  setColumnFilters: (columnFilters) => set({ columnFilters }),
  setUniqueValues: (uniqueValues) => set({ uniqueValues }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),

  // === UI Actions ===

  // Form actions
  openCreateForm: () => set({
    isFormOpen: true,
    isEditMode: false,
    selectedMethod: null,
    error: null
  }),

  openEditForm: (method) => set({
    isFormOpen: true,
    isEditMode: true,
    selectedMethod: method,
    error: null
  }),

  closeForm: () => set({
    isFormOpen: false,
    isEditMode: false,
    selectedMethod: null,
    error: null
  }),

  // Delete dialog actions
  openDeleteDialog: (method) => set({
    isDeleteDialogOpen: true,
    methodToDelete: method
  }),

  closeDeleteDialog: () => set({
    isDeleteDialogOpen: false,
    methodToDelete: null
  }),

}));

export default useApplicationMethodStore;
